import { Row } from "reactstrap";
import Icon from "../../components/Icon/Icon";

const HotelStars = ({ stars }) => {
  const numberOfStars = stars || 0;

  return (
    <Row className="mr-md-1">
      <small className="text-muted" style={{ marginTop: '1px', marginLeft: '2px' }}>5/</small>
      <p>{numberOfStars}</p>
      <Icon name="star-fill" className="text-warning ml-1" />
    </Row>
  );
};

export default HotelStars;
